__turbopack_context__.v({
  "article": "CVideoGalleryOuter-module__monL2a__article",
  "articleBack": "CVideoGalleryOuter-module__monL2a__articleBack",
  "articleBackLink": "CVideoGalleryOuter-module__monL2a__articleBackLink",
  "articleText": "CVideoGalleryOuter-module__monL2a__articleText",
  "articleTitle": "CVideoGalleryOuter-module__monL2a__articleTitle",
  "card": "CVideoGalleryOuter-module__monL2a__card",
  "cardLink": "CVideoGalleryOuter-module__monL2a__cardLink",
  "citySelect": "CVideoGalleryOuter-module__monL2a__citySelect",
  "empty": "CVideoGalleryOuter-module__monL2a__empty",
  "filterBar": "CVideoGalleryOuter-module__monL2a__filterBar",
  "grid": "CVideoGalleryOuter-module__monL2a__grid",
  "pagerBtn": "CVideoGalleryOuter-module__monL2a__pagerBtn",
  "pagerInfo": "CVideoGalleryOuter-module__monL2a__pagerInfo",
  "pagination": "CVideoGalleryOuter-module__monL2a__pagination",
  "root": "CVideoGalleryOuter-module__monL2a__root",
  "search": "CVideoGalleryOuter-module__monL2a__search",
  "text": "CVideoGalleryOuter-module__monL2a__text",
  "title": "CVideoGalleryOuter-module__monL2a__title",
  "videoFallback": "CVideoGalleryOuter-module__monL2a__videoFallback",
  "videoFrame": "CVideoGalleryOuter-module__monL2a__videoFrame",
  "videoWrap": "CVideoGalleryOuter-module__monL2a__videoWrap",
});
